import { GroupAdBlock } from './blocks.types'
import { getGroupAdBlockMappings } from './block-mappings'
import { shadowStandard, YStack } from '@my/ui'
import { AdBrand } from '../components/ad/ad-brand'

export interface GroupAd {
  id: string
  title?: string
  isBrandAd: boolean
  link?: string
  brand?: {
    id: string
    name: string
    logo: {
      url: string
      alt: string
    }
    slug: string
  }
  logo?: {
    url: string
    alt: string
  }
  ad: GroupAdBlock[]
}

export interface GroupAdBlockRendererProps extends GroupAd {}

/**
 * This will allow rendering of a Group Ad in the FlatList
 */
export const GroupAdBlockRenderer = (props: GroupAdBlockRendererProps) => {
  const componentsMap = getGroupAdBlockMappings()

  const ad = props.ad?.[0]

  if (!ad) return null

  const createBlock = (ad: GroupAdBlock) => {
    const extraProps = {
      key: `${ad.id}`,
      id: ad.id,
    }

    const { Component } = componentsMap[ad.blockType] || {}

    if (!Component) {
      return null
    }

    const brand = props.isBrandAd
      ? {
          id: props.brand?.id || '',
          name: props.brand?.name || '',
          logo: {
            url: props.brand?.logo?.url || '',
            alt: props.brand?.logo?.alt || '',
          },
          href: `/discounts/${props.brand?.slug}`,
        }
      : {
          id: props.title || '',
          name: props.title || '',
          logo: {
            url: props.logo?.url || '',
            alt: props.logo?.alt || '',
          },
          href: props.link || '',
        }

    return (
      <YStack bg="$white" pt={brand ? '$0' : '$3.5'} br="$3" {...shadowStandard}>
        {brand && <AdBrand brand={brand} />}
        <Component {...ad} {...extraProps} />
      </YStack>
    )
  }

  return createBlock(ad)
}
